<template>
  <Profile ref="profile">
    <template v-slot:boldTextArea>
      <h1 class="con_ttl">활동하실 프로필 정보를<br />등록해 주세요.</h1>
    </template>

    <template v-slot:btnArea>
      <div class="btn_wrap">
        <button class="btn" @click="saveProfile">저장하기</button>
      </div>
    </template>
  </Profile>
</template>

<script>
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import Profile from './components/Profile';

export default {
  components: { Profile },
  data() {
    return {};
  },
  created() {
    if (this.userProfile.nickname) {
      this.$router.push({ name: 'Auth.Region' });
    }
  },
  computed: {
    ...userMapGetters({
      userProfile: userTypes.USER,
    }),
  },
  methods: {
    ...commonMapActions([commonActions.FILE_UPLOAD]),
    ...userMapActions([userTypes.USER_UPDATE_ME]),
    async saveProfile() {
      if (!this.$refs.profile.checkedValidation) {
        this.$refs.profile.errorMsg = '닉네임 중복 확인 해주세요';
        return false;
      } else {
        const params = [
          { name: 'nickname', value: this.$refs.profile.model.inputValue },
        ];
        const payload = new FormData();
        for (const i in params) {
          payload.append(params[i].name.toString(), params[i].value);
        }

        if (this.$refs.profile.file !== null) {
          payload.append('userPicture', this.$refs.profile.file.blob);
        }

        this[userTypes.USER_UPDATE_ME](payload)
          .then(() => {
            this.$router.push({ name: 'Auth.ProfileComplete' });
          })
          .catch(() => {});
      }
    },
  },
};
</script>
